"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personalEditorialCategoryOrPageQuery = void 0;
var _fetching = require("@ori/fetching");
var _personalEditorialArticlePageFragment = require("./personalEditorialArticlePageFragment");
var _personalEditorialCategoryPageFragment = require("./personalEditorialCategoryPageFragment");
const personalEditorialCategoryOrPageQuery = exports.personalEditorialCategoryOrPageQuery = (0, _fetching.gql)`
  query PersonalEditorialCategoryOrPage(
    $pageId: ID!
    $landingPageId: ID
    $includeThemeItems: Boolean! = false
    $includeRoot: Boolean! = true
  ) {
    application {
      ...PersonalEditorialArticlePage
      ...PersonalEditorialCategoryPage
    }
  }
  ${_personalEditorialCategoryPageFragment.personalEditorialCategoryPageFragment}
  ${_personalEditorialArticlePageFragment.personalEditorialArticlePageFragment}
`;
